<script>
  import {Line,mixins} from "vue-chartjs";
  const {reactiveProp} = mixins

  export default {
    extends: Line,
    mixins: [reactiveProp],
    props: {
      chartData: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    watch: {
      chartData() {
        // this method can be used for updating data too
        this.$data._chart.update()
      }
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    }
  };

</script>
